import { TextEditor } from "constants/Actions";
import { IAPIAction } from "interfaces";
import { ITextAction } from "interfaces/TextEditor";

const {
  SAVE_TEXT_DATA,
  SAVE_TEXT_DATA_SUCCESS,
  SAVE_TEXT_DATA_FAIL,

  SET_DRAWER_PROPERTIES,
  SET_DRAWER_PROPERTIES_SUCCESS,
  SET_DRAWER_PROPERTIES_FAIL,

  GET_STANDARD_ADAPTERS,
  GET_STANDARD_ADAPTERS_SUCCESS,
  GET_STANDARD_ADAPTERS_FAIL,

  DELETE_TEXT_DATA,
  DELETE_TEXT_DATA_SUCCESS,
  DELETE_TEXT_DATA_FAIL,
} = TextEditor;

export const textEditor: Readonly<IAPIAction & ITextAction> = {
  textData: {
    update: (data) => ({
      type: SAVE_TEXT_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SAVE_TEXT_DATA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SAVE_TEXT_DATA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  drawer: {
    set: (data) => ({
      type: SET_DRAWER_PROPERTIES,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SET_DRAWER_PROPERTIES_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SET_DRAWER_PROPERTIES_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  adapter: {
    get: (data) => ({
      type: GET_STANDARD_ADAPTERS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_STANDARD_ADAPTERS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_STANDARD_ADAPTERS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  text: {
    delete: (data) => ({
      type: DELETE_TEXT_DATA,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: DELETE_TEXT_DATA_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: DELETE_TEXT_DATA_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
};
